import React from 'react';
import { ChangeZone } from 'domain/shared/core/dashboard';
import { SxProps } from '@mui/system';

interface DashboardIssuesButtonFieldProps {
  buttonSx?: SxProps;
  currentZoneSource?: string;
  availableOnlyForZoneView?: boolean;
}

const DashboardIssuesButtonField: React.FC<DashboardIssuesButtonFieldProps> = ({
  currentZoneSource = 'retentionRiskPriority',
  availableOnlyForZoneView,
  ...props
}) => {
  return (
    <ChangeZone currentZoneSource={currentZoneSource} availableOnlyForZoneView={availableOnlyForZoneView} {...props} />
  );
};

export default DashboardIssuesButtonField;
